import template from './employee_end_linked_leave.html';
import tr from '../../lib/default-translator.js';

class EmployeeEndLeaveTypeViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.end_date = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async save_end_leave()
	{
		let obj = {
			employee_id: this.dialog.bindings.employee_id,
			leave_linked_id: this.dialog.bindings.leave_linked_id,
			end_date: this.end_date()
		};

		let res = await Grape.fetches.postJSON('/leave/end_linked_leave', obj);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully ended leave.'), title: tr('Success', 'Success')});
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};
};

class EmployeeEndLeaveTypePage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeEndLeaveTypeViewModel(this);
		this.bindings = bindings;		
	};

	init()
	{

	}
};

export default {
	name: 'EmployeeEndLeaveType',
	dialog_class: EmployeeEndLeaveTypePage,
	template: template,
	template_filename: 'translation/dialogs/employee_end_linked_leave',
	provider: 'ps'
};
